/**
 * Lazy visibility for collection promo videos (plays when visible, pauses when not).
 * Image elements use native loading="lazy"; this handles muted autoplay policy.
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  /** @param {Element} root */
  function bindPromo(root) {
    if (root.getAttribute('data-promo-initialized') === 'true') return;

    const video = root.querySelector('video[data-promo-video]');
    if (!video) {
      root.setAttribute('data-promo-initialized', 'true');
      return;
    }

    const auto = root.getAttribute('data-promo-autoplay-visible') === 'true';

    if (prefersReducedMotion()) {
      try {
        video.pause();
      } catch (e) {}
      video.removeAttribute('autoplay');
      root.setAttribute('data-promo-initialized', 'true');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const visible = entry.isIntersecting && entry.intersectionRatio >= 0.2;
          if (!visible) {
            try {
              if (!video.paused) video.pause();
            } catch (e) {}
            return;
          }
          if (prefersReducedMotion()) return;
          if (auto) {
            const p = video.play();
            if (p && typeof p.catch === 'function') {
              p.catch(function () {});
            }
          }
        });
      },
      { threshold: [0, 0.2, 0.6, 1], rootMargin: '0px' }
    );

    observer.observe(root);
    root.setAttribute('data-promo-initialized', 'true');
  }

  function initAll() {
    document.querySelectorAll('[data-collection-promo-root]:not([data-promo-initialized])').forEach(function (root) {
      bindPromo(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('theme:variant-infinite-scroll:loaded', initAll);
  document.addEventListener('theme:global-collection-promo:placed', initAll);

  var grid = document.querySelector('[data-products-grid]');
  if (grid && typeof MutationObserver !== 'undefined') {
    var timer;
    var mo = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(initAll, 80);
    });
    mo.observe(grid, { childList: true, subtree: true });
  }
})();
